import Intercom, { showNewMessage, shutdown } from "@intercom/messenger-js-sdk";
import { useUserSettings } from "./useUserSettings";

export default function useIntercom() {
  const { data: user } = useUserSettings();
  const appId = process.env.REACT_APP_INTERCOM_APP_ID;

  const launch = (extraProps?: Record<string, any>) => {
    if (appId && user) {
      Intercom({
        app_id: appId,
        email: user.email,
        user_id: user.email,
        ...extraProps,
      });
    }
  };

  const setMarginBottom = (marginBottom: number) => {
    launch({
      vertical_padding: marginBottom,
    });
  };

  const hide = () => {
    shutdown();
  };

  const newMessage = (message?: string) => {
    showNewMessage(message || "");
  };

  return { launch, hide, newMessage, setMarginBottom };
}
